import { dateIsInFuture } from '@sleepstation/utils'
import dayjs from 'dayjs'
import { pipe, prop } from 'ramda'
import localStorageService from './localStorageService'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const localStorageApi = localStorageService()

const isValid = pipe(prop(`expires`), dateIsInFuture)

const addAuthorisation = (token, context) => {
  const expires = dayjs().add(7, `days`).format()
  localStorageApi.setValue(context, { expires, token })
}

const getIsAuthorised = (context) => {
  const authData = localStorageApi.getObject(context)
  return !!(authData && isValid(authData))
}

const authenticate = (
  navigate,
  { redirectUrlInvalid, redirectUrlValid, context }
) =>
  new Promise((resolve, reject) => {
    const isAuthorised = getIsAuthorised(context)

    if (isAuthorised) {
      // There are some pages we don't want a user to be on if they are already
      // authorised, for example a signup page. If redirectUrlValid is present,
      // we redirect them there.
      if (redirectUrlValid) {
        navigate(redirectUrlValid)
      }
      resolve()
    } else {
      // if redirectUrlInvalid is supplied, we redirect them there. Otherwise we
      // do nothing (they are on a signup page).
      if (redirectUrlInvalid) {
        navigate(redirectUrlInvalid)
        reject()
      }
      resolve()
    }
  })

const authenticationService = { authenticate, addAuthorisation }

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export default authenticationService
